// extracted by mini-css-extract-plugin
export var docType = "training-document-module--docType--YiQhm";
export var icon = "training-document-module--icon--ZmFp6";
export var row = "training-document-module--row--wlsmB";
export var subText = "training-document-module--subText--RR5bH";
export var textContainer = "training-document-module--textContainer--MyUo9";
export var title = "training-document-module--title--pzBh3";